import React, { useEffect } from 'react';
import CreditApplicationsMonitorTable from './CreditApplicationsMonitorTable';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { getSupplierCreditApplicationsMonitor } from '../../../../redux/services/creditApplicationsMonitorService';

const CreditMonitoringApp = () => {
  const dispatch = useAppDispatch();

  const { creditApplicationsMonitor } = useAppSelector((state) => state.creditApplicationsMonitor);
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  useEffect(() => {
    if (!currentSupplier?.id) return;
    dispatch(getSupplierCreditApplicationsMonitor({ supplierId: currentSupplier?.id ?? '' }));
  }, [currentSupplier?.id]);

  return (
    <div className="h-full flex flex-col">
      <CreditApplicationsMonitorTable creditApplicationsMonitor={creditApplicationsMonitor ?? []} />
    </div>
  );
};

export default CreditMonitoringApp;
